var map = {
	"./BannerConversa": 28,
	"./BannerConversa.png": 28,
	"./BannerConversaTolas": 29,
	"./BannerConversaTolas.png": 29,
	"./LogoIcoConversa": 30,
	"./LogoIcoConversa.png": 30,
	"./LogoSofia_": 31,
	"./LogoSofia_.png": 31,
	"./ico_conversa_close": 32,
	"./ico_conversa_close.png": 32,
	"./ico_conversa_float": 33,
	"./ico_conversa_float.png": 33,
	"./ico_sofia": 22,
	"./ico_sofia.png": 22,
	"./ico_sofia30": 19,
	"./ico_sofia30.png": 19,
	"./ico_sofia30.svg": 74,
	"./ico_sofia30_": 34,
	"./ico_sofia30_.png": 34,
	"./ico_sofia_close": 35,
	"./ico_sofia_close.png": 35,
	"./logoConversa": 36,
	"./logoConversa.png": 36,
	"./logoConversaIco": 37,
	"./logoConversaIco.png": 37,
	"./logo_Conversa_Color": 38,
	"./logo_Conversa_Color.png": 38,
	"./logo_Conversa_Color_Part": 39,
	"./logo_Conversa_Color_Part.png": 39,
	"./logo_sofia30_color": 40,
	"./logo_sofia30_color.png": 40,
	"./logo_sofia_color": 41,
	"./logo_sofia_color.webp": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;